import React, { useEffect, useState } from 'react';

function UserIP() {
  const [ipAddress, setIpAddress] = useState('');

  useEffect(() => {
    const getUserIP = async () => {
      try {
        // Try the API method first as it's more reliable
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();
        if (data.ip) {
          setIpAddress(data.ip);
          return;
        }
      } catch (error) {
        console.error("API IP detection failed:", error);
      }

      // Fallback to WebRTC method if API fails
      // not sure how this works, check on this more..
      try {
        const RTCPeerConnection = window.RTCPeerConnection || window.webkitRTCPeerConnection || window.mozRTCPeerConnection;

        if (!RTCPeerConnection) {
          throw new Error("RTCPeerConnection not supported.");
        }

        const pc = new RTCPeerConnection({
          iceServers: [{ urls: "stun:stun.l.google.com:19302" }]
        });

        pc.createDataChannel("");
        
        // Create and set the offer
        const offer = await pc.createOffer();
        await pc.setLocalDescription(offer);

        // Wait for ICE gathering
        const candidates = [];
        
        pc.onicecandidate = (event) => {
          if (event.candidate) {
            if (event.candidate.candidate) {
              const ipMatch = event.candidate.candidate.match(/([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/);
              if (ipMatch && ipMatch[1] && !ipMatch[1].startsWith('192.168') && !ipMatch[1].startsWith('127.0.0')) {
                setIpAddress(ipMatch[1]);
                pc.close();
              }
            }
          } else {
            // ICE gathering complete
            pc.close();
          }
        };

      } catch (error) {
        console.error("WebRTC IP detection failed:", error);
        setIpAddress('Unable to detect');
      }
    };

    getUserIP();

    // Cleanup function
    return () => {
      // Any cleanup if needed
    };
  }, []);

  return ipAddress ||  '...' ;
}

export default UserIP;